import WelcomeHeader from "../components/modules/dashboard/WelcomeHeader";
import AIBanner from "../components/modules/dashboard/AIBanner";
import StatsGrid from "../components/modules/dashboard/StatsGrid";
import ActivityChart from "../components/modules/dashboard/ActivityChart";
import QuickActions from "../components/modules/dashboard/QuickActions";
import RecentProjects from "../components/modules/dashboard/RecentProjects";
import PrototypeJourney from "../components/modules/dashboard/PrototypeJourney";

export default function Dashboard() {
  return (
    <div className="space-y-6">
      <WelcomeHeader name="Arjun" />
      <AIBanner />
      <StatsGrid />

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <ActivityChart />
        </div>
        <QuickActions />
      </div>

      <RecentProjects />
      <PrototypeJourney projectId="APIC-2411-0142" currentIndex={6} />
    </div>
  );
}